var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductClipboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "25px",
    width: "25px",
    fill: "#DDDDDD",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    d: "M305.8,0H158.7c-27,0-50.3,21.4-50.3,48.4v10.2h-9.3c-27,0-50.3,21.4-50.3,48.4v354.7 c0,27,22.3,50.3,50.3,50.3h256c27,0,48.4-22.3,48.4-50.3v-9.3h11.2c27,0,48.4-22.3,48.4-50.3V157.3L305.8,0z M305.8,54.9 l102.4,102.4H305.8C305.8,157.3,305.8,54.9,305.8,54.9z M364.5,461.7c0,5.6-3.7,10.2-9.3,10.2h-256c-5.6,0-10.2-4.7-10.2-10.2V108 c0-4.7,4.7-9.3,10.2-9.3h9.3v314.6c0,27,13,40,40,40h216V461.7z M424,403.1c0,5.6-3.7,10.2-9.3,10.2h-256 c-5.6,0-10.2-4.7-10.2-10.2V48.4c0-4.7,4.7-9.3,10.2-9.3h108v157.3H424V403.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductClipboard);
export default __webpack_public_path__ + "static/media/product-clipboard.2a68c24fc6d356ec1d9e2961847204f3.svg";
export { ForwardRef as ReactComponent };